"use client"

import {ModalProvider} from "@/components/DownloaderApp/Modal";

import {NetworkProvider} from "@/components/DownloaderApp/Network";
import {PremiumProvider} from "@/components/DownloaderApp/usePremium";
import {
    QueryClientProvider,
} from '@tanstack/react-query'
import {queryClient} from "@/components/DownloaderApp/queryClient";
import BulkTwitchDownload from "@/components/DownloaderApp/BulkTwitchDownload";
import {MonitoringProvider} from "@/components/monitoring";

export default function App(props) {
    return <QueryClientProvider client={queryClient}>
        <MonitoringProvider>
            <ModalProvider><PremiumProvider>
                <NetworkProvider>
                    <BulkTwitchDownload {...props} />
                </NetworkProvider>
            </PremiumProvider></ModalProvider></MonitoringProvider></QueryClientProvider>
}